import { Bar, BarChart, CartesianGrid, Rectangle, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts"

export default function DespesasGraficoBarStatusRelatorios({ relatorios, despesas, handleRelatorioStatusSelecionado }: iProps) {

    function handleData(): any[] {
        let relatoriosAux = handleRelatoriosSelecionados(relatorios, despesas)

        let registros: any[] = []
        for (let relatorio of relatoriosAux) {
            const STATUS = relatorio.id_status.descricao
            const PESQUISA = registros.filter(reg => reg.status === STATUS)
            const JA_ADICIONADO = PESQUISA.length === 0 ? false : true

            if (JA_ADICIONADO) {
                let index = registros.indexOf(PESQUISA[0])
                if (index < 0) {
                    continue
                }
                registros[index]["qtd"] = registros[index]["qtd"] + 1
            }

            if (!JA_ADICIONADO) {
                registros.push({
                    status: STATUS,
                    qtd: 1,
                })
            }
        }
        registros.sort(function (a, b) { return b.qtd - a.qtd })
        return registros
    }

    // const renderCustomizedLabel = (props: any) => {
    //     const { x, y, width, value } = props;
    //     const radius = 10;
    //     return (
    //         <g>
    //             <text x={x + width / 2} y={y - radius} fill="#000" textAnchor="middle" dominantBaseline="middle">
    //                 {value}
    //             </text>
    //         </g>
    //     );
    // };
    return (
        <div style={{ width: "50%" }}>
            <p style={{ textAlign: "right", fontWeight: "bold" }}>Quantidade de Relatórios X Status</p>
            <div id="graph_horas" className="graph_backgrounds" style={{ width: "100%", margin: "10px 0px 10px 0px" }}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        width={500}
                        height={300}
                        data={handleData()}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="status" />
                        <YAxis dataKey="qtd" />
                        <Tooltip />
                        <Bar dataKey="qtd" onClick={(event) => { handleRelatorioStatusSelecionado(event) }} fill="#128FE2" activeBar={<Rectangle fill="gold" stroke="purple" />} label={{ fill: "black" }}>
                            {/* <LabelList dataKey="qtd" content={renderCustomizedLabel} /> */}
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    )
}
interface iProps {
    relatorios: any[]
    despesas: any[]
    handleRelatorioStatusSelecionado: any
}

export function handleRelatoriosSelecionados(relatorios: any[], despesas: any[]):any[] {
    let relatoriosAux: any[] = []
    for (let despesa of despesas) {
        const ID_RELATORIO = despesa.id_relatorio.id_relatorio
        const JA_ADICIONADO = relatoriosAux.filter(reg => reg.id_relatorio === ID_RELATORIO).length === 0 ? false : true
        if (JA_ADICIONADO) { continue }

        let relatorio: any = {}
        const RELATORIOS_FILTER = relatorios.filter(reg => reg.id_relatorio === ID_RELATORIO)
        if (RELATORIOS_FILTER.length === 0) { continue }

        relatorio = RELATORIOS_FILTER[0]
        relatoriosAux.push(relatorio)
    }
    return relatoriosAux
}
